import { computed, del, reactive, set } from "@vue/composition-api";

/**
 * Article selection for the "Veille globale" tab.
 *
 * The list is paginated server-side, so the selection has to survive page
 * changes. The previous implementation kept an id array plus a map rebuilt from
 * the current page only, which silently dropped items selected on other pages,
 * and mutated the map with plain assignment / delete — invisible to Vue 2's
 * reactivity. Here the normalised item itself is the single source of truth, and
 * `set` / `del` keep the store observable so a live counter stays accurate.
 */
export function useGlobalWatchSelection() {
  const state = reactive({ byId: {} });

  const selectedItems = computed(() => Object.values(state.byId));
  const selectedIds = computed(() => selectedItems.value.map((item) => item.id));
  const count = computed(() => selectedItems.value.length);

  const isSelected = (id) =>
    Object.prototype.hasOwnProperty.call(state.byId, id);

  const toggle = (item) => {
    if (!item || item.used) return;

    if (isSelected(item.id)) {
      del(state.byId, item.id);
    } else {
      set(state.byId, item.id, item);
    }
  };

  const clear = () => {
    state.byId = {};
  };

  return {
    clear,
    count,
    isSelected,
    selectedIds,
    selectedItems,
    toggle,
  };
}
